/**
 * English is the source of truth: every key here must exist in hy.ts and
 * ru.ts (typechecked via `Dict`). Keys are dot-namespaced by screen.
 * `{name}` placeholders are filled by t(key, { name }).
 */
export const en = {
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.send": "Send",
  "common.sending": "Sending…",
  "common.next": "Next",
  "common.change": "Change",
  "common.signIn": "Sign in",
  "common.return": "Return",
  "common.somethingWrong": "Something went wrong, please try again",

  "header.language": "Language",
  "header.home": "Home",
  "header.shop": "Shop",
  "header.account": "My card",
  "header.menu": "Menu",
  "header.support": "Support",
  "header.profileSettings": "Profile settings",
  "header.blog": "Blog",
  "header.admin": "Admin",
  "header.signOut": "Sign out",

  "footer.copyright": "© {year} Powered by Touch Talk. All Rights Reserved",

  "home.createNfc": "Create your NFC",
  "home.createStyle": "Create your communication style",
  "home.step1": "Analyze the packages",
  "home.step2": "Create your Talk version",
  "home.step3": "Order one and make your business available.",
  "home.getStarted": "Get started",
  "home.partners": "Our partners",
  "home.loginHint": "If you have an account you can login",
  "home.reachTitle": "One Tap Endless Reach",
  "home.reachText": "Create a digital profile for your contact details, social links, portfolio, and business information. Share it instantly with a single tap.",

  "support.link": "Support",
  "support.title": "For support",
  "support.success": "Your message was successfully sent",
  "support.email": "Email*",
  "support.message": "Message*",

  "order.title": "For order",
  "order.package": "Package",
  "order.packageOption": "Package {title}",
  "order.name": "Name*",
  "order.phone": "Phone number*",

  "shop.plans": "PLANS",
  "shop.shops": "SHOPS",
  "shop.blurb":
    "With a single subscription, you get more than just a digital business card: enjoy a sleek NFC card, free replacements, and continuous support throughout the year.",
  "shop.nfcCards": "NFC Cards",
  "shop.nfcStickers": "NFC Stickers",
  "shop.petTag": "Pet Tag",
  "shop.mostPopular": "MOST POPULAR",
  "shop.metalCard": "Metal Card",
  "shop.woodenCard": "Wooden Card",
  "shop.emailLabel": "Email address",
  "shop.phoneLabel": "Phone number",
  "shop.invalidEmail": "Invalid email address",
  "shop.invalidPhone": "Invalid phone number",
  "shop.submitted": "Your order was submitted. We will contact you shortly.",
  "shop.card": "Card",
  "shop.sales": "Sales",
  "shop.subscriptionFor": "Subscription for {period}",
  "shop.total": "Total",
  "shop.order": "Order",
  "shop.addons": "Exclusive addons",
  "shop.perMonth": "per month",
  "shop.getStarted": "Get started",
  "shop.addon.metalCard": "Metal card",

  "plans.basic.title": "INCLUDE 1 PC OF",
  "plans.basic.description": "TOUCH TALK visit card or sticker",
  "plans.pro.title": "PET NECK TAG",
  "plans.pro.description": "and page function",
  "plans.period.1": "1 Month",
  "plans.period.3": "3 Months",
  "plans.period.6": "6 Months",
  "plans.period.12": "12 Months",
  "plans.option.socialNetworks": "Social networks",
  "plans.option.messengers": "Messengers",
  "plans.option.url": "URL",
  "plans.option.savingContacts": "Saving contacts",
  "plans.option.brandedCard": "Branded card",
  "plans.option.customButtons": "Custom design of your page buttons",
  "plans.option.background": "Ability to change background",
  "plans.option.map": "Map function",
  "plans.option.review": "Review function",
  "plans.option.swipe": "Swipe photos on your page",
  "plans.option.replacement": "Free replacement of standard PVC card",
  "plans.option.petPage": "Pet page making",

  "blog.title": "Ideas for Smarter Connections",
  "blog.all": "All",
  "blog.tag": "Tag",
  "blog.clear": "clear",
  "blog.by": "by",
  "blog.noPosts": "No posts yet.",
  "blog.loadFailed": "Failed to load posts.",
  "blog.back": "Back to blog",
  "blog.notFound": "This post could not be found.",
  "blog.sources": "Sources",
  "blog.published": "Published {date}.",
  "blog.accessed": "Accessed {date}.",

  "pages.plans.title": "Choose the Plan That Fits You",
  "pages.plans.cta": "Compare plans in the shop",
  "pages.partners.title": "Trusted by Teams and Businesses",
  "pages.contact.title": "Contact TouchTalk",
  "pages.contact.cta": "Write to support",
  "pages.privacy.title": "Privacy Policy",
  "pages.privacy.pending": "The privacy policy is being prepared.",
  "pages.terms.title": "Terms and Conditions",
  "pages.terms.pending": "The terms and conditions are being prepared.",

  "auth.username": "Username",
  "auth.password": "Password",
  "auth.forgot": "Forgot password?",
  "auth.accept": "I accept",
  "auth.terms": "Terms And Conditions",
  "auth.signingIn": "Signing in…",
  "auth.errFields": "Please enter your username and password",
  "auth.errWrong": "Wrong username/email or password",
  "auth.errServer": "Can't reach the server. Please try again.",
  "auth.resetTitle": "Reset password",
  "auth.createTitle": "Create password",
  "auth.failed": "Failed",
  "auth.resetSubtitle": "Enter your new password",
  "auth.newPassword": "New Password",
  "auth.confirmPassword": "Confirm Password",
  "auth.confirm": "Confirm",
  "auth.mismatch": "Password and confirm password do not match",
  "auth.findAccount": "Find Your Account",
  "auth.findHint": "Enter your email or username and we will send you a reset link",
  "auth.success": "Success",
  "auth.checkEmail": "Check your email",
  "auth.notFound": "Sorry, we couldn't find your account. Please contact our support.",
  "auth.emailOrUsername": "Email or Username",

  "settings.profile": "Profile information",
  "settings.picture": "Your profile picture",
  "settings.pictureTitle": "Profile picture",
  "settings.name": "Name",
  "settings.surname": "Surname",
  "settings.email": "Email",
  "settings.phone": "Phone number",
  "settings.updatePassword": "Update password",
  "settings.currentPassword": "Current Password",
  "settings.newPassword": "New Password",
  "settings.confirmPassword": "Confirm Password",

  "profile.addToContacts": "Add to contacts",

  "validation.tooLong": "No more than {max} characters.",
  "validation.pattern": "Please enter the data in the specified format.",
  "validation.tooShort": "Must be at least {min} characters.",
  "validation.required": "This value is required!",

  "cropper.title": "Crop image",
  "cropper.drag": "Drag to reposition",
  "cropper.readError": "Could not read this image. Please try another one.",
  "cropper.uploadError": "Upload failed. Please try again.",
  "cropper.zoom": "Zoom",
  "cropper.zoomIn": "Zoom in",
  "cropper.zoomOut": "Zoom out",
  "cropper.uploading": "Uploading…",

  "builder.saving": "Saving…",
  "builder.saved": "Saved",
  "builder.saveError": "Couldn't save — check your connection",

  "tour.skip": "Skip",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.stepOf": "{n} of {total}",
  "tour.help": "Show tips",
  "tour.s1.title": "Your card",
  "tour.s1.text": "This is your NFC card page. Everything you add here appears when someone taps your card.",
  "tour.s2.title": "Add sections",
  "tour.s2.text": "Tap Add Section to add your profile, links, messengers, photos or a map.",
  "tour.s3.title": "Edit & reorder",
  "tour.s3.text": "Tap a section to edit it. Drag to reorder, swipe left to delete.",
  "tour.s4.title": "Preview",
  "tour.s4.text": "Switch to preview to see exactly what visitors see.",
  "tour.s5.title": "Share",
  "tour.s5.text": "Use the menu to copy your link, download the QR code or switch cards.",
  "form.show": "Show",
  "form.hide": "Hide",
  "cropper.maxSide": "max {px}px",
  "builder.card": "Card",
  "builder.addCard": "Add card",
  "builder.adding": "Adding…",
  "builder.newCardName": "New card",
  "builder.rename": "Rename {name}",
  "builder.saveName": "Save name",
  "builder.copyLink": "Copy card link",
  "builder.copied": "Copied",
  "footer.tagline": "NFC business cards that keep working: share your contacts, links and profile with one tap.",
  "footer.product": "Product",
  "footer.company": "Company",
  "footer.shop": "Shop",
  "footer.plans": "Plans",
  "footer.blog": "Blog",
  "footer.partners": "Partners",
  "footer.contact": "Contact",
  "footer.privacy": "Privacy policy",
  "footer.terms": "Terms and conditions",
  // Hints, help guide and action tooltips (builder).
  "section.text.hint": "A short intro, opening hours or an offer.",
  "section.link.hint": "A button that opens any web page, file or booking form.",
  "section.profile.hint": "Your photo, name and role — the header of your card.",
  "section.messengers.hint": "WhatsApp, Telegram, Instagram and more — visitors tap to reach you.",
  "section.swipe.hint": "A photo gallery; each photo can open its own link.",
  "section.map.hint": "Your location with directions.",
  "hint.profile": "Upload a square photo, enter your name and what you do. This is what visitors see first.",
  "hint.text": "Keep it short — two or three lines read best on a phone. To make a word clickable, select it and tap Link.",
  "hint.link": "Paste the full address (https://…). Give it a short title — it becomes the button text.",
  "hint.messengers": "Tap “Add new section” to pick apps, then enter your number or profile link. Visitors tap the icon and the app opens with your chat.",
  "hint.swipe": "Add a few photos. Each slide can have its own link; leave it empty to use the default link.",
  "hint.map": "Tap the map to drop the pin and type the address. Visitors get directions in one tap.",
  "hint.background": "Pick a colour or upload a photo. Dark backgrounds keep white text readable.",
  "hint.external": "Use this only if you want your card to open another website instead of your profile.",
  "help.title": "How it works",
  "help.intro": "Short recipes for the most common tasks. Tap a topic to expand it.",
  "help.profile.title": "Create your profile",
  "help.profile.s1": "Tap “Add Section” at the bottom and choose “Profile pic.”.",
  "help.profile.s2": "Upload a square photo — it is cropped to a circle or a cover, depending on the style you pick.",
  "help.profile.s3": "Enter your name and your role or company.",
  "help.profile.s4": "Tap “Save”. Changes are saved automatically from then on.",
  "help.socials.title": "Add socials and messengers",
  "help.socials.s1": "Tap “Add Section” and choose “Messengers”.",
  "help.socials.s2": "Tap “Add new section” to open the catalog: WhatsApp, Telegram, Viber, Instagram, Facebook, LinkedIn, TikTok and more.",
  "help.socials.s3": "Tap the apps you want, then “Save”.",
  "help.socials.s4": "Under each app enter your phone number (messengers) or your profile link (socials).",
  "help.socials.s5": "On the “Design” tab choose icons or buttons and the colours. Then “Save”.",
  "help.links.title": "Add links and files",
  "help.links.s1": "Tap “Add Section” and choose “Link”.",
  "help.links.s2": "Enter a short title — it becomes the button text — and paste the full address starting with https://.",
  "help.links.s3": "Optionally upload an icon; the “Design” tab sets colours, corners and shadow.",
  "help.links.s4": "Tap “Save”. Add as many links as you need: website, menu, price list, booking form, a PDF.",
  "help.photos.title": "Add photos",
  "help.photos.s1": "Tap “Add Section” and choose “Swipe Photo”.",
  "help.photos.s2": "Tap “Upload photo” and crop each picture (all slides share the same 4:3 frame).",
  "help.photos.s3": "Give a slide its own link, or set one default link for all slides.",
  "help.photos.s4": "Turn on “Autoswipe” if you want the gallery to move by itself. Then “Save”.",
  "help.map.title": "Add your location",
  "help.map.s1": "Tap “Add Section” and choose “Map”.",
  "help.map.s2": "Tap the map to drop the pin and type your address and a headline.",
  "help.map.s3": "Tap “Save”. Visitors open directions in one tap.",
  "help.background.title": "Change the background",
  "help.background.s1": "Tap the pencil button at the bottom and choose “Change profile background”.",
  "help.background.s2": "Pick a colour, or upload a photo (9:16 works best on phones).",
  "help.background.s3": "Tap “Save”. Text colours in each section can be adjusted on its “Design” tab.",
  "help.cards.title": "Your cards",
  "help.cards.s1": "A card is one public page with its own link and QR code. Each NFC card you order opens one of them.",
  "help.cards.s2": "The name at the top of the builder is the current card. Tap it to switch between your cards.",
  "help.cards.s3": "In that list, tap “Add card” to create another one — for a second business, a team member or an event.",
  "help.cards.s4": "Tap the pencil next to a card to rename it.",
  "help.cards.s5": "To remove a card, open the pencil menu at the bottom and choose “Delete this card”.",
  "help.share.title": "Share your card",
  "help.share.s1": "Tap the link icon next to the card name to copy your public link.",
  "help.share.s2": "In the pencil menu choose “Show QR code” to display or download the QR.",
  "help.share.s3": "With a physical TouchTalk card, visitors simply tap it with their phone — no app needed.",
  "help.share.s4": "Turn on “Show contact saver” in the pencil menu so visitors can add you to their contacts in one tap.",
  "help.order.title": "Order a physical card",
  "help.order.s1": "Open the Shop and pick a card design and a plan.",
  "help.order.s2": "Fill in the order form; we contact you to confirm the details.",
  "help.order.s3": "When the card arrives it already opens your profile — everything you build here is live on it.",
  "help.order.cta": "Go to the shop",
  "help.replayTour": "Replay the tour",
  "help.showHints": "Show hints again",
  "help.hintsReset": "Hints will show again",
  "tip.preview": "Preview as a visitor",
  "tip.edit": "Back to editing",
  "tip.menu": "Menu: QR code, background, remove sections",
  "tip.drag": "Drag to reorder",
  "tip.help": "How it works",
};

export type TranslationKey = keyof typeof en;
export type Dict = Record<TranslationKey, string>;
